import useGetDomainName from './useGetDomainName'

export default useGetDomainName
